import { VehicleState } from "./vehicle.types";

export const state: VehicleState = {
  vehicles: [],
  loading: false,
  pagination: null
};
